/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/linkedin_medium'
export default icon
